var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['header__menu-wrap', {'header__menu-wrap_subitems-opened': _vm.subitemsOpened}]},[_vm._t("default",null,{"openSubitems":_vm.openSubitems,"closeSubitems":_vm.closeSubitems,"toggleSubitemsLvl2":_vm.toggleSubitemsLvl2})],2)}
var staticRenderFns = []

export { render, staticRenderFns }